import axios from 'axios'

const API_URL = process.env.VUE_APP_BACKEND_API_URL + '/instruments'

class InstrumentService {

    read(id) {
        return axios
            .get(API_URL + '/' + id)
    }

    readAll(page, size, sort, descending, q) {
        const params = new URLSearchParams()
        params.append('page', page)
        params.append('size', size)
        if (sort) {
            params.append('sort', sort + (descending ? ',desc' : ',asc'))
        }
        if (q) {
            params.append('q', q)
        }

        return axios
            .get(API_URL + '/', {
                params: params
            })
    }

    readAllBenchmarks(page, size, sort, descending) {
        return axios
            .get(API_URL + "/index", {
                params: {
                    page: page,
                    size: size,
                    sort: sort ? sort + (descending ? ',desc' : ',asc') : null
                }
            })
    }

    readAllInstruments(page, size, sort, descending) {
        return axios
            .get(API_URL + "/share", {
                params: {
                    page: page,
                    size: size,
                    sort: sort ? sort + (descending ? ',desc' : ',asc') : null
                }
            })
    }

    readAllHotBenchmarks(page, size, sort, descending) {
        return axios
            .get(API_URL + "/hot-index", {
                params: {
                    page: page,
                    size: size,
                    sort: sort ? sort + (descending ? ',desc' : ',asc') : null
                }
            })
    }

    readAllHotInstruments(page, size, sort, descending) {
        return axios
            .get(API_URL + "/hot-share", {
                params: {
                    page: page,
                    size: size,
                    sort: sort ? sort + (descending ? ',desc' : ',asc') : null
                }
            })
    }

    readAllValuatedInstruments(page, size, sort, descending) {
        return axios
            .get(API_URL + "/valuated-share", {
                params: {
                    page: page,
                    size: size,
                    sort: sort ? sort + (descending ? ',desc' : ',asc') : null
                }
            })
    }

    readActions(id) {
        return axios
            .get(API_URL + '/' + id + '/actions')
    }

    readPerformances(id) {
        return axios
            .get(API_URL + '/' + id + '/quotes')
    }
}

export default new InstrumentService()
